module.exports = __webpack_public_path__ + "static/media/font-icon.da9ae860.svg";